const routers = [
    {
        path: '/forget_psw',
        name: 'forget_psw',
        meta: {
            exp: '忘记密码',
            requireAuth: false
        },
        component: () => import('@/views/account/forget_psw/index.vue'),
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            exp: '登录',
            requireAuth: false
        },
        component: () => import('@/views/account/login/index.vue'),
    },
    {
        path: '/register',
        name: 'register',
        meta: {
            exp: '注册',
            requireAuth: false
        },
        component: () => import('@/views/account/reigster/index.vue'),
    },
]
export default routers